import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import './vendor_dropdown.css';
import { fetchCategories } from '../../../API/Resources/fetchCategories';

export default function VendorDropdown() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Define chunkArray inside useEffect to make it accessible
    const chunkArray = (arr, chunkSize) => {
      const chunks = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
      }
      return chunks;
    };

    const loadCategories = async () => {
      try {
        const category_data = await fetchCategories();

        if (category_data && category_data.length > 0) {
          const categoriesWithPaths = category_data.map(cat => ({
            ...cat,
            path: `/vendors/${cat.category_name.replace(/\s/g, '-')}`
          }));

          const chunkSize = Math.ceil(categoriesWithPaths.length / 3);
          const columns = chunkArray(categoriesWithPaths, chunkSize);
          setCategories(columns);
        }
      } catch (error) {
        console.error("Failed to load categories:", error);
      }
    };

    loadCategories();
  }, []); // The empty dependency array ensures this runs only once

  return (
    <div className="vendor-dropdown-menu">
      <Row className="g-2" style={{ height: "max-content" }}>
        {categories.map((column, colIndex) => (
          <Col xs={12} md={4} key={colIndex}>
            <ul className="list-unstyled vendor-list">
              {column.map((category, vendorIndex) => (
                <section className="mb-4">
                  <li className="category-title">
                    {category.category_name}
                  </li>
                  <li key={vendorIndex}>
                    <Link to={category.path} className="category-subtitle" >{category.category_name}</Link>
                    {category.subcategories && category.subcategories.length > 0 && (
                      <p className="sub-category">{category.subcategories.join(', ')}</p>
                    )}
                  </li>
                </section>
              ))}
            </ul>
          </Col>
        ))}
      </Row>
    </div>
  );
}